<template>
  <section>
    <b-modal v-model="isCardModalActive" :width="640" :can-cancel="false">
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <ProfileCard :player="player" />
          <p class="modal-card-title">Invitation Sent</p>
          <button type="button" class="delete" @click="cancelChallenge" />
        </header>
        <section class="modal-card-body is-flex">
          <figure class="image is-48x48">
            <img @src="KNIGHT_WHITE" />
          </figure>
          <div class="content">
            You have invited
            {{ player.first_name }}
            {{ player.school ? " from " + player.school.school_name : "" }} to a
            {{ challenge.duration / 60 }}-minute {{ challenge.variant }} game
            <br />
            <small>
              {{ new Date(challenge.createdAt).toLocaleTimeString() }}
            </small>
          </div>
        </section>
        <footer
          class="modal-card-foot is-flex is-justify-content-space-between"
        >
          <TimerDisplay
            v-if="duration"
            :duration="duration - waitingTime"
            run="true"
          />
          <div class="buttons">
            <b-button
              label="Cancel"
              type="is-danger"
              @click="cancelChallenge"
            />
          </div>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import ProfileCard from "@/components/players/ProfileCard.vue";
import TimerDisplay from "@/components/TimerDisplay";
import { CHESS_SVG } from "@/utils/chess-svg";

export default {
  components: { ProfileCard, TimerDisplay },

  props: ["player", "duration"],

  data() {
    return {
      isCardModalActive: false,
      waitingTime: null,
      timerInterval: null,
      rtdbTimeOffset: 0,
      KNIGHT_WHITE: CHESS_SVG.KNIGHT_WHITE,
    };
  },

  computed: {
    challenge() {
      if (!this.player) return null;
      return this.player.challenge;
    },
  },

  watch: {
    challenge: {
      immediate: true,
      handler() {
        if (!this.challenge || !this.challenge.createdAt) {
          this.isCardModalActive = false;
          this.stopTimer();
        } else {
          this.isCardModalActive = true;
          this.startTimer();
        }
      },
    },
  },

  methods: {
    cancelChallenge() {
      console.log("Modal cancelChallenge", this.waitingTime, this.duration);
      this.stopTimer();
      this.isCardModalActive = false;
      this.$emit("onCancelChallenge");
      // this.$parent.close();
    },

    startTimer() {
      if (!this.challenge) return;
      if (!this.challenge.createdAt) return;
      if (this.timerInterval) return;
      console.log("startTimer");
      this.timerInterval = setInterval(() => {
        if (!this.challenge || !this.challenge.createdAt) {
          this.stopTimer();
          return;
        }
        this.waitingTime =
          (new Date().getTime() +
            this.rtdbTimeOffset -
            this.challenge.createdAt) /
          1000; // in seconds

        if (this.duration && this.waitingTime > this.duration) {
          this.cancelChallenge();
        }
      }, 1000);
    },

    stopTimer() {
      console.log("stopTimer");
      clearInterval(this.timerInterval);
      this.timerInterval = null;
      this.waitingTime = null;
    },
  },

  created() {
    this.rtdbTimeOffset = parseInt(sessionStorage.getItem("rtdbTimeOffset"));
    if (!this.rtdbTimeOffset) this.rtdbTimeOffset = 0;
  },

  beforeDestroy() {
    this.stopTimer();
  },
};
</script>
